/** 获取知识文库列表操作类型 */
enum OperateType {
  Upload = 1,
  Download = 2,
  Delete = 3,
  Copy = 4,
  Move = 5,
}

const acceptPostfix = [
  'doc',
  'docx',
  'pdf',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'png',
  'jpeg',
  'jpg',
  'bmp',
  'msg',
  'mht',
  'zip',
  '7z',
  'rar',
]

const bigAcceptPostfix = [
  'zip',
  '7z',
  'rar',
]

export { OperateType, acceptPostfix, bigAcceptPostfix }
